<template>
	<h3 class="hh3">
		<slot></slot>
	</h3>
</template>

<script>
export default {
	name: 'Hh3',
}
</script>

<style lang="scss" scoped>
.hh3 {
	margin: 22px 0 10px;
	font-size: 1.2rem;
	color: #16323a;
	font-weight: 700;
	line-height: 1.35;
}
</style>
